export const openPopupWindow = url => {
  const windowType = 'popUpWindow';

  const left = window.screen.width / 2 - 250;
  const top = window.screen.height / 2 - 290;
  const popupParams = `location=0,status=0,width=500,height=580,left=${left},top=${top}`;

  return window.open(url, windowType, popupParams);
};
